import { computed, defineComponent, ref } from 'vue';
import { useSweetAlert } from '@/composables/sweetalert';
import { useStore } from 'vuex';
import { EmergencyAction, EmergencyGetter } from '@/store/emergency/emergency.module';
import { Emergency, EmergencyAttachment } from '@/store/emergency/emergency.model';
import BaseModalComponent from '@/components/baseModal/BaseModal.vue';

export default defineComponent({
  name: 'EmergencyAttachmentModelComponent',
  components: {
    BaseModalComponent
  },
  props: {
    emergencyId: {
      type: Number,
    }
  },
  emits: [
    'upload',
    'hidden',
  ],
  setup: (props, context) => {
    const swal = useSweetAlert();
    const store = useStore();
    const emergency = computed<Emergency>(() => store.getters[EmergencyGetter.BY_ID](props.emergencyId));
    const attachments = computed<EmergencyAttachment[]>(() => (emergency.value) ? emergency.value?.emergencyAttachments.filter(m => m.attachmentType.id === 1) : []);
    const isLoading = computed<boolean>(() => store.getters[EmergencyGetter.STATUS] === 'init' || store.getters[EmergencyGetter.STATUS] === 'loading');
    const attachmentModal = ref<InstanceType<typeof BaseModalComponent>>();

    // show modal
    const show = () => {
      attachmentModal.value?.show();
    };

    // hide modal
    const hide = () => {
      attachmentModal.value?.hide();
    };

    // upload click
    const uploadClick = () => {
      context.emit('upload', emergency.value?.id);
    };

    // delete click
    const deleleClick = (id: number) => {
      swal.confirm('ลบข้อมูล!', 'คุณต้องการลบข้อมูลใช่หรือไม่?', 'ใช่ ลบเดี๋ยวนี้!', '#dc3545')
        .then((result) => {
          if (result.isConfirmed) {
            store.dispatch(EmergencyAction.REMOVE_ATTACHMENTS, {
              id: emergency.value?.id,
              attachmentIds: [id],
            });
          }
        });
    };

    // hidden
    const handleHidden = () => {
      context.emit('hidden', emergency.value?.id);
    };

    return {
      attachments,
      attachmentModal,
      isLoading,
      show,
      hide,
      uploadClick,
      deleleClick,
      handleHidden,
    };
  },
});
